import { useState } from 'react'
import { Button } from 'antd'
import useTranslation from '../../hooks/useTranslation'

import GetHelp from '../../features/tickets/components/GetHelp'
import Send from '../svgs/Send'

const NeedHelp = () => {
  const { t } = useTranslation()

  const [isHelpVisible, setIsHelpVisible] = useState(false)

  return (
    <>
      <div className='mt-40 pb-40'>
        <div className='bg-[#1B222A] rounded-xl px-12 pt-28 pb-12 w-11/12 mx-auto text-center relative'>
          <h4 className='text-[#f2f2f2] text-xs font-semibold mb-8'>
            {t('Need Help ?')}
          </h4>
          <p className='text-[#AAA] text-xs leading-5 mb-8'>
            {t('Our support team is at your disposal')}
          </p>
          <Button
            className='btn-green text-sm font-semibold rounded-lg py-12 mt-6 h-auto w-full'
            onClick={() => setIsHelpVisible(true)}
          >
            {t('Get help')}
          </Button>

          <div className='absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-green border border-4 border-[#262f39] w-36 h-36 rounded-full flex items-center justify-center'>
            <Send style='w-16' />
          </div>
        </div>
      </div>

      <GetHelp open={isHelpVisible} setOpen={setIsHelpVisible} />
    </>
  )
}

export default NeedHelp
